import React, {useState} from "react";
import {Send} from "lucide-react";
import {whatsappApi} from "../../config/api";
import {normalizeClientPhone} from "../../calander/eventWhatsApp";
import Button from "../Common/Button";
import {FormSection, FormField, inputClass} from "./SettingsUI";

const DEFAULT_MESSAGE = "Ceci est un message de test envoyé depuis votre back-office.";

// Sends a free message through the account's linked WhatsApp, to check the
// connection really works — same `/send` call as the POS tablets
// (pos_clone screens/settings/WhatsAppSettings.js › handleTestSend).
const WhatsAppTestSend = ({accountUuid, showNotification}) => {
    const [phone, setPhone] = useState("");
    const [message, setMessage] = useState(DEFAULT_MESSAGE);
    const [sending, setSending] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const to = normalizeClientPhone(phone);
        if (!to) {
            showNotification("error", "Numéro de téléphone invalide");
            return;
        }
        setSending(true);
        try {
            const {data} = await whatsappApi.post("/send", {
                number: accountUuid,
                message: message.trim() || DEFAULT_MESSAGE,
                to,
                type: "chat",
            });
            if (data?.status === true) {
                // The normalized number, so a wrongly typed one is visible right away
                showNotification("success", `Message de test envoyé au +${to}`);
            } else {
                showNotification("error", "Échec de l'envoi du message de test");
            }
        } catch (error) {
            console.error("Erreur lors de l'envoi du message de test:", error);
            showNotification("error", "Échec de l'envoi du message de test");
        } finally {
            setSending(false);
        }
    };

    return (
        <FormSection
            title="Tester l'envoi"
            description="Envoyez un message pour vérifier que votre compte WhatsApp fonctionne."
        >
            <form onSubmit={handleSubmit} className="space-y-4">
                <FormField
                    id="whatsappTestPhone"
                    label="Numéro de téléphone"
                    hint="Numéro marocain, ou avec l'indicatif (+33…) pour l'étranger."
                >
                    <input
                        id="whatsappTestPhone"
                        type="tel"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        placeholder="+212 6 12 34 56 78"
                        className={inputClass()}
                    />
                </FormField>
                <FormField id="whatsappTestMessage" label="Message">
                    <textarea
                        id="whatsappTestMessage"
                        rows={3}
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        className={inputClass()}
                    />
                </FormField>
                <Button type="submit" variant="primary" icon={Send} loading={sending} disabled={!phone.trim()}>
                    Envoyer un test
                </Button>
            </form>
        </FormSection>
    );
};

export default WhatsAppTestSend;
